import React from "react";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppFloat() {
  const waLink =
    "https://api.whatsapp.com/send/?phone=923337223262&text&type=phone_number&app_absent=0";

  return (
    <a
      href={waLink}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="
        fixed bottom-6 right-6 z-[9999]
        h-14 w-14 md:h-16 md:w-16
        rounded-full bg-[#25D366] text-white
        flex items-center justify-center
        shadow-lg hover:shadow-xl
        hover:scale-105 active:scale-95
        transition-all
      "
    >
      <FaWhatsapp className="text-3xl md:text-4xl" />
    </a>
  );
}
